// Libraries
import * as Yup from 'yup'

// Mirrors the backend register validators (auth.middlewares.js): name 2-100,
// valid email, password min 8 + at least one special character — the same two
// criteria rendered live in the StepAccountDetails checklist (per Figma).
const RegisterSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('Name is required')
    .min(2, 'Name must be 2-100 characters')
    .max(100, 'Name must be 2-100 characters'),
  email: Yup.string()
    .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, 'email must be a valid email')
    .required('Email is required'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Must be at least 8 characters')
    .matches(/[^a-zA-Z0-9]/, 'Must contain one special character'),
})

export default RegisterSchema
